const initState = {
  verifySeasonalBadges: {},
  verifyMomento: {},
  veryEndorsement: {},
  talkingBadges: {},
  myBadges: {},
  verifyEndorsementBadge: {},
};
const VerifyBadgesReducers = (state = initState, action) => {
  switch (action.type) {
    case "VERIFY_TALKING_BADGES":
      return {
        ...state,
        talkingBadges: action.payload,
      };
    case "VERIFY_MY_BADGES":
      return {
        ...state,
        myBadges: action.payload,
      };
    case "VERIFY_SEASONAL_BADGES":
      return {
        ...state,
        verifySeasonalBadges: action.payload,
      };
    case "VERIFY_MOMENTO":
      return {
        ...state,
        verifyMomento: action.payload,
      };

    case "VERIFY_ENDORSEMENT_BADGE_BY_ID":
      return {
        ...state,
        verifyEndorsementBadge: action.payload,
      };
    case "VERIFY_ENDORSEMENT_BADGE":
      return {
        ...state,
        veryEndorsement: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};
export default VerifyBadgesReducers;
